/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItems_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_user">;
    readonly " $refType": "PdpRespSellerItems_user";
};
export type PdpRespSellerItems_user$data = PdpRespSellerItems_user;
export type PdpRespSellerItems_user$key = {
    readonly " $data"?: PdpRespSellerItems_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSellerItems_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItems_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'a870e43d449884562f281bc5391a86ee';
export default node;
